"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var TemplateContainer = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function TemplateContainer() {
    var _this;
    (0, _classCallCheck2["default"])(this, TemplateContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TemplateContainer, [].concat(args));
    (0, _defineProperty2["default"])(_this, "_templateSetter", function (cmp) {
      _this._template = cmp;
    });
    return _this;
  }
  (0, _inherits2["default"])(TemplateContainer, _React$Component);
  return (0, _createClass2["default"])(TemplateContainer, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.anySelected !== nextProps.anySelected || this.props.itemSelected !== nextProps.itemSelected || this.props.item !== nextProps.item || this.props.template !== nextProps.template || this.props.commonProps !== nextProps.commonProps;
    }
  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this._template;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        item = _this$props.item,
        itemSelected = _this$props.itemSelected,
        anySelected = _this$props.anySelected,
        dragHandleProps = _this$props.dragHandleProps,
        commonProps = _this$props.commonProps;
      var Template = this.props.template;
      return /*#__PURE__*/React.createElement(Template, {
        ref: this._templateSetter,
        item: item,
        itemSelected: itemSelected,
        anySelected: anySelected,
        dragHandleProps: dragHandleProps,
        commonProps: commonProps
      });
    }
  }]);
}(React.Component);
module.exports = exports.default;
module.exports.default = exports.default;
//# sourceMappingURL=TemplateContainer.js.map